import { render, staticRenderFns } from "./send-reminder-deal-modal.vue?vue&type=template&id=69bf661c"
import script from "./send-reminder-deal-modal.ts?vue&type=script&lang=js&external"
export * from "./send-reminder-deal-modal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports